import ListAltIcon from '@mui/icons-material/ListAlt';
import HistoryIcon from '@mui/icons-material/History';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
// import DeleteIcon from '@mui/icons-material/Delete';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import StorageIcon from '@mui/icons-material/Storage';
import FeedbackIcon from '@mui/icons-material/Feedback';
import TarefasPage from "../Tarefa";
import DashboardContent from "../Dashboard";
import Historico from "../Historico";
// import Lixeira from "../Lixeira";
import Arquivos from "../Arquivos";
import CentralBackups from "../CentralBackups";
import Sugestao from "../Sugestao";
import Dispositivos from "../Dispositivos";
import DevicesIcon from "@mui/icons-material/Devices";
import InstallDesktopIcon from "@mui/icons-material/InstallDesktop";
import InstalacaoPage from "../Instalacao";

export interface MenuLateral {
    titulo: string,
    componente: JSX.Element,
    icone: JSX.Element,
    rota: string
}

const menus: Array<MenuLateral> = [{
    titulo: 'Dashboard',
    componente: <DashboardContent />,
    icone: <InsertChartOutlinedIcon />,
    rota: '/dashboard'
},
{
    titulo: 'Central de Backups',
    componente: <CentralBackups />,
    icone: <StorageIcon />,
    rota: '/central-backups'
},
{
    titulo: 'Arquivos Recentes',
    componente: <Arquivos />,
    icone: <InsertDriveFileIcon />,
    rota: '/arquivos-recentes'
},
{
    titulo: 'Tarefas',
    componente: <TarefasPage />,
    icone: <ListAltIcon />,
    rota: '/tarefas'
},
  {
    titulo: 'Dispositivos',
    componente: <Dispositivos />,
    icone: <DevicesIcon />,
    rota: '/dispositivos'
  },
  {
    titulo: 'Instalação',
    componente: <InstalacaoPage />,
    icone: <InstallDesktopIcon />,
    rota: '/instalacao'
  },
{
    titulo: 'Históricos',
    componente: <Historico />,
    icone: <HistoryIcon />,
    rota: '/historicos'
},
/* {
    titulo: 'Lixeira',
    componente: <Lixeira />,
    icone: <DeleteIcon />,
    rota: '/lixeira'
}, */
{
    titulo: 'Fale Conosco',
    componente: <Sugestao />,
    icone: <FeedbackIcon />,
    rota: '/fale-conosco'
}];

export default menus;